const mod = () => {
  const limitDist = 15;
  const modelspeed = 0.01;
  const rotationspeed = 0.01;
  let currentCameraPosition = {
    x: 0,
    y: 0,
    z: 0,
  };
  let touchInprogress = false;
  return {
    touchHandler: (
      getPosition,
      setPosition,
      setLightCameraPosition,
      getRotation,
      setRotation,
      event,
      sceneDetails,
      setOpacity
    ) => {
      console.log("touchHandler");

      if (event.type === "pointerdown") {
        touchInprogress = true;
      } else if (event.type === "pointerup") {
        touchInprogress = false;
      }
      if (touchInprogress) {
        if (
          sceneDetails != null &&
          typeof sceneDetails === "function" &&
          "camera" in sceneDetails()
        ) {
          currentCameraPosition = sceneDetails()?.camera?.position;
        }
        const currentModelPosition = getPosition();
        const currentModelRotation = getRotation();
        if (event.touches === 2) {
          let deltaX = 0;
          let deltaZ = 0;
          let newx = currentModelPosition.x;
          let newz = currentModelPosition.z;
          const relx = currentModelPosition.x - currentCameraPosition.x;
          const relz = currentModelPosition.z - currentCameraPosition.z;
          const dist = Math.sqrt(relx ** 2 + relz ** 2);
          deltaZ = modelspeed * event.delta[1];
          deltaX = modelspeed * event.delta[0];
          newx =
            (dist - deltaZ) * (relx / dist) +
            currentCameraPosition.x -
            (deltaX * relz) / dist;
          newz =
            (dist - deltaZ) * (relz / dist) +
            currentCameraPosition.z +
            (deltaX * relx) / dist;

          const newdist = Math.sqrt(
            (newx - currentCameraPosition.x) ** 2 +
              (newz - currentCameraPosition.z) ** 2
          );
          let positionToSet = {
            x: currentModelPosition.x,
            y: currentModelPosition.y,
            z: currentModelPosition.z,
          };
          if (newdist > 0.25 && newdist < limitDist) {
            positionToSet = {
              x: newx,
              y: currentModelPosition.y,
              z: newz,
            };
          }
          setLightCameraPosition(positionToSet);
          setPosition(positionToSet);
        } else if (event.touches === 1) {
          if (event.axis === "x") {
            const rotationToSet = {
              y: currentModelRotation.y + event.delta[0] * rotationspeed,
            };
            setRotation(rotationToSet);
          }
        } else if (event.touches === 3) {
          if (event.axis === "y") {
            let newy = currentModelPosition.y - event.delta[1] * modelspeed;
            if (newy < 0 || newy > limitDist) {
              newy = currentModelPosition.y;
            }
            const positionToSet = {
              x: currentModelPosition.x,
              y: newy,
              z: currentModelPosition.z,
            };
            setOpacity(newy);
            setPosition(positionToSet);
          }
        }
      }
    },
  };
};

const touchEvents = mod();

export default touchEvents;
